import React, { useState, useEffect, useRef } from 'react'
import { makeStyles } from '@material-ui/core'
import Typography from '@material-ui/core/Typography'
import IconButton from '@material-ui/core/IconButton'
import CloseIcon from '@material-ui/icons/Close'
import { CapeeshColors } from '../../../../assets/ColorPalette'

const useStyles = makeStyles((theme) => ({
    topBar: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: '8px 16px',
        backgroundColor: 'rgba(0, 0, 0, 0.3)',
        minHeight: 48,
        zIndex: 10,
        '@media (max-width: 599px)': {
            padding: '4px 8px',
            minHeight: 44,
        },
    },
    closeButton: {
        color: '#FFFFFF',
    },
    hudRight: {
        display: 'flex',
        alignItems: 'center',
        gap: 16,
    },
    nodeInfo: {
        fontFamily: 'Rubik',
        fontSize: 13,
        fontWeight: 400,
        color: 'rgba(255, 255, 255, 0.7)',
        '@media (max-width: 599px)': { fontSize: 11 },
    },
    scoreContainer: {
        display: 'flex',
        alignItems: 'center',
        gap: 6,
    },
    scoreLabel: {
        fontFamily: 'Rubik',
        fontSize: 14,
        fontWeight: 600,
        color: '#FFFFFF',
        '@media (max-width: 599px)': { fontSize: 12 },
    },
    scoreDelta: {
        fontFamily: 'Rubik',
        fontSize: 12,
        fontWeight: 600,
        color: CapeeshColors.GreenBright,
        opacity: 0,
        transition: 'opacity 300ms ease, transform 300ms ease',
        transform: 'translateY(8px)',
    },
    scoreDeltaVisible: {
        opacity: 1,
        transform: 'translateY(0)',
    },
    progressBarContainer: {
        width: '100%',
        height: 4,
        backgroundColor: 'rgba(255, 255, 255, 0.15)',
    },
    progressBarFill: {
        height: '100%',
        backgroundColor: CapeeshColors.GreenBright || '#4CAF50',
        transition: 'width 400ms ease-in-out',
    },
}))

/**
 * LessonHUD — progress bar, score display, quit button.
 */
const LessonHUD = ({
    progressPercent,
    currentNodeIndex,
    totalNodes,
    currentNodeTypeName,
    lessonScore,
    onQuit,
}) => {
    const classes = useStyles()
    const [scoreDelta, setScoreDelta] = useState(null)
    const prevScore = useRef(lessonScore)

    useEffect(() => {
        if (lessonScore > prevScore.current) {
            const delta = lessonScore - prevScore.current
            setScoreDelta(`+${Math.round(delta * 100)}`)
            const timer = setTimeout(() => setScoreDelta(null), 1500)
            prevScore.current = lessonScore
            return () => clearTimeout(timer)
        }
        prevScore.current = lessonScore
    }, [lessonScore])

    return (
        <>
            <div className={classes.topBar}>
                <IconButton className={classes.closeButton} onClick={onQuit}>
                    <CloseIcon />
                </IconButton>
                <div className={classes.hudRight}>
                    <div className={classes.scoreContainer}>
                        <Typography className={classes.scoreLabel}>
                            {Math.round(lessonScore * 100)}
                        </Typography>
                        {scoreDelta && (
                            <Typography
                                className={`${classes.scoreDelta} ${classes.scoreDeltaVisible}`}
                            >
                                {scoreDelta}
                            </Typography>
                        )}
                    </div>
                    <Typography className={classes.nodeInfo}>
                        {currentNodeIndex + 1} / {totalNodes}
                    </Typography>
                </div>
            </div>
            <div className={classes.progressBarContainer}>
                <div
                    className={classes.progressBarFill}
                    style={{ width: `${progressPercent}%` }}
                />
            </div>
        </>
    )
}

export default LessonHUD
